import { render, staticRenderFns } from "./viewPurchaseOrder.vue?vue&type=template&id=72ed10a3&"
import script from "./viewPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./viewPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./viewPurchaseOrder.vue?vue&type=style&index=0&id=72ed10a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports